/* eslint-disable react/prop-types */
/* eslint-disable react/forbid-prop-types */
import 'url-search-params-polyfill';

import React from 'react';
import NumberFormat from 'react-number-format';

// useState

// import PropTypes from 'prop-types';

import { Input, Form, Radio, Select, Card } from 'antd';

import * as productOptions from './options';
import './pricingTab.scss';

const { TextArea } = Input;
const { Option } = Select;

const Header = block => {
  const { values, changeValues } = block;
  const radioStyle = {
    display: 'block',
    height: '30px',
    lineHeight: '30px',
  };

  const createOptions = obj => {
    if (!obj) {
      return '';
    }
    const objKeys = Object.keys(obj);

    const options = objKeys.map(key => {
      const text = obj[key];
      const value = key;
      return <Option value={value}>{text}</Option>;
    });
    return options;
  };
  console.log(values);
  return (
    <div>
      <div className="tab-wrapper-small">
        <p>NSN/PN: {values.nsnOrPn}</p>{' '}
        <p>Nomenclature: {values.nomenclature}</p>
      </div>

      <div style={{ paddingBottom: 16 }}>
        <Form layout="vertical">
          <Form.Item
            label={
              <p style={{ fontWeight: 800, margin: 0 }}>
                Item Description Indicator
              </p>
            }
          >
            <Select
              onChange={value => changeValues('itemDescInd', value)}
              value={values.itemDescInd}
            >
              {createOptions(productOptions.itemDescription)}
            </Select>
          </Form.Item>

          {(values.itemDescInd === 'P' ||
            values.itemDescInd === 'B' ||
            values.itemDescInd === 'N') && (
            <div>
              {' '}
              <Form.Item
                label={
                  <p style={{ fontWeight: 600, margin: 0 }}>
                    Part Number Offered?
                  </p>
                }
              >
                <div className="product-wrapper">
                  <div className="product-partnum-flex">
                    <p>Part Number Code Offered</p>
                    <Select
                      value={values.partNumOffrd}
                      onChange={value => changeValues('partNumOffrd', value)}
                    >
                      {createOptions(productOptions.pnOfferedCode)}
                    </Select>
                  </div>
                </div>
              </Form.Item>
              <Form.Item>
                <div className="product-wrapper">
                  <div className="product-partnum-flex">
                    <p>Part Number Offered CAGE code</p>
                    <Input
                      value={values.pnOffrdCage}
                      onChange={e =>
                        changeValues('pnOffrdCage', e.target.value)
                      }
                    />
                  </div>
                </div>
              </Form.Item>
              <Form.Item>
                <div className="product-wrapper">
                  <div className="product-partnum-flex">
                    <p>Part Number Offered Part Number</p>
                    <Input
                      value={values.pnOffrdPartNum}
                      onChange={e =>
                        changeValues('pnOffrdPartNum', e.target.value)
                      }
                    />
                  </div>
                </div>
              </Form.Item>
              {values.partNumOffrd &&
                values.partNumOffrd !== '1' && (
                  <Card>
                    Part Number Offered Remarks
                    <TextArea
                      rows={6}
                      value={values.pnOffrdRmks}
                      onChange={e =>
                        changeValues('pnOffrdRmks', e.target.value)
                      }
                    />
                  </Card>
                )}
            </div>
          )}

          {(values.itemDescInd === 'D' ||
            values.itemDescInd === 'B' ||
            values.itemDescInd === 'Q') && (
            <Form.Item
              label={
                <p style={{ fontWeight: 800, margin: 0 }}>Supplies Offered?</p>
              }
            >
              <div>
                <Radio.Group
                  value={values.suppOffrd}
                  onChange={e => {
                    changeValues('suppOffrd', e.target.value);
                  }}
                >
                  <Radio style={radioStyle} value="1">
                    Supplies In Accordance With All SPEC/STD/DWGS Cited In The
                    Solicitation Item Description.
                  </Radio>
                  <Radio style={radioStyle} value="2">
                    Supplies Based On Different Revision Of Any SPEC/STD/DWGS
                    Cited In the Solicitation Item Description.
                  </Radio>
                  <Radio style={radioStyle} value="3">
                    Supplies Based On Changes To SPEC/STD/DWGS Cited In The
                    Solicitation Item Description.
                  </Radio>
                  <Radio style={radioStyle} value="4">
                    Supplies Based On Other Technical Data / Solicitation Item
                    Description In Error.
                  </Radio>
                </Radio.Group>
              </div>
              {values.suppOffrd &&
                values.suppOffrd !== '1' && (
                  <Card>
                    Supplies Offered Remarks
                    <TextArea
                      value={values.suppOffrdRmks}
                      rows={6}
                      onChange={e =>
                        changeValues('suppOffrdRmks', e.target.value)
                      }
                    />
                  </Card>
                )}
            </Form.Item>
          )}

          {values.itemDescInd === 'Q' && (
            <div>
              <Form.Item
                label={
                  <p style={{ fontWeight: 800, margin: 0 }}>
                    Qualification Requirements
                  </p>
                }
              >
                <div className="product-wrapper">
                  <div className="product-partnum-flex">
                    <p>Qualification Requirements MFG CAGE</p>
                    <Input
                      value={values.qualReqMfgCage}
                      onChange={e =>
                        changeValues('qualReqMfgCage', e.target.value)
                      }
                    />
                  </div>
                </div>
              </Form.Item>
              <Form.Item>
                <div className="product-wrapper">
                  <div className="product-partnum-flex">
                    <p>Qualification Requirements Source CAGE</p>
                    <Input
                      value={values.qualReqSrcCage}
                      onChange={e =>
                        changeValues('qualReqSrcCage', e.target.value)
                      }
                    />
                  </div>
                </div>
              </Form.Item>
              <Form.Item>
                <div className="product-wrapper">
                  <div className="product-partnum-flex">
                    <p>Qualification Requirements Item Name</p>
                    <Input
                      value={values.qualReqItemNm}
                      onChange={e =>
                        changeValues('qualReqItemNm', e.target.value)
                      }
                    />
                  </div>
                </div>
              </Form.Item>
              <Form.Item>
                <div className="product-wrapper">
                  <div className="product-partnum-flex">
                    <p>Qualification Requirements Service Identification</p>
                    <Input
                      value={values.qualReqSvcId}
                      onChange={e =>
                        changeValues('qualReqSvcId', e.target.value)
                      }
                    />
                  </div>
                </div>
              </Form.Item>
              <Form.Item>
                <div className="product-wrapper">
                  <div className="product-partnum-flex">
                    <p>Qualification Requirements Test Number</p>
                    <Input
                      value={values.qualReqTstNum}
                      onChange={e =>
                        changeValues('qualReqTstNum', e.target.value)
                      }
                    />
                  </div>
                </div>
              </Form.Item>
            </div>
          )}

          <Form.Item
            label={
              <p style={{ fontWeight: 800, margin: 0 }}>Higher-level Quality</p>
            }
          >
            <div>
              <p>
                Identify the Higher-level quality standard/system compliance for
                the facility which supplies are being manufactured
              </p>
              <div>
                <p>
                  Note: if offering either AS9100 or a standard not listed.
                  please select{' "OTHER EQUILVALENT" '} then type those
                  standards with the revision number that applies to your
                  company in the text box titled{
                    ' "Enter other higher-level quality standard/system" '
                  }
                </p>
              </div>
              <div>
                <Select
                  value={values.highLevQualInd}
                  onChange={value => {
                    changeValues('highLevQualInd', value);
                  }}
                >
                  {createOptions(productOptions.higherLevel)}
                </Select>
              </div>
            </div>
          </Form.Item>

          {values.highLevQualInd === '7' && (
            <Form.Item
              label={
                <p style={{ fontWeight: 800, margin: 0 }}>
                  Higher-Level Quality Code
                </p>
              }
            >
              <Select
                value={values.highLevQualCd}
                onChange={value => {
                  changeValues('highLevQualCd', value);
                }}
              >
                {createOptions(productOptions.higherSeven)}
              </Select>
            </Form.Item>
          )}
          {values.highLevQualInd === '6' && (
            <Form.Item
              label={
                <p style={{ fontWeight: 800, margin: 0 }}>
                  Higher-Level Quality Code
                </p>
              }
            >
              <Select
                value={values.highLevQualCd}
                onChange={value => {
                  changeValues('highLevQualCd', value);
                }}
              >
                {createOptions(productOptions.higherSix)}
              </Select>
            </Form.Item>
          )}
          {values.highLevQualCd === '2' && (
            <Form.Item
              label={<p>Enter other higher-level quality standard/system</p>}
            >
              <TextArea
                value={values.highLevQualRmks}
                onChange={e => {
                  changeValues('highLevQualRmks', e.target.value);
                }}
              />
            </Form.Item>
          )}
          <Form.Item
            label={
              <p style={{ fontWeight: 800, margin: 0 }}>
                Trade Agreements Indicator
              </p>
            }
          >
            <div>
              <Select
                value={values.trdAgmtsInd}
                onChange={value => {
                  changeValues('trdAgmtsInd', value);
                }}
              >
                {createOptions(productOptions.tradeIndicator)}
              </Select>
            </div>
          </Form.Item>

          <Form.Item
            label={
              <p style={{ fontWeight: 800, margin: 0 }}>Manufacturer/Dealer</p>
            }
          >
            <div>
              <Select
                value={values.manufDlr}
                onChange={value => {
                  changeValues('manufDlr', value);
                }}
              >
                {createOptions(productOptions.manufacturer)}
              </Select>
            </div>
          </Form.Item>

          {(values.manufDlr === 'DD' || values.manufDlr === 'QD') && (
            <div>
              <Form.Item
                label={
                  <p style={{ fontWeight: 800, margin: 0 }}>
                    Actual Manufacturing/Production Details:
                  </p>
                }
              >
                <div className="product-wrapper">
                  <div className="product-partnum-flex">
                    <p> Source CAGE code</p>
                    <Input
                      value={values.manufCage}
                      maxLength="5"
                      style={{ width: '10%' }}
                      onChange={e => changeValues('manufCage', e.target.value)}
                    />
                  </div>
                </div>
              </Form.Item>
              <Form.Item>
                <div className="product-wrapper">
                  <div className="product-partnum-flex">
                    <p>if Cage is Unkown, Enter Source Name and Address</p>

                    <Input
                      value={values.manufNmAddr}
                      onChange={e =>
                        changeValues('manufNmAddr', e.target.value)
                      }
                    />
                  </div>
                </div>
              </Form.Item>
            </div>
          )}
          <Form.Item
            label={
              <p style={{ fontWeight: 800, margin: 0 }}>
                Material Requirements{' '}
              </p>
            }
          >
            <Select
              value={values.matRqmts}
              onChange={value => {
                changeValues('matRqmts', value);
              }}
            >
              {createOptions(productOptions.matType)}
            </Select>
          </Form.Item>

          <Form.Item
            label={
              <p style={{ fontWeight: 800, margin: 0 }}>
                Buy American Act/Free Trade Agreements
              </p>
            }
          >
            <div className="product-wrapper">
              <div className="product-partnum-flex">
                <p> Buy American</p>
                <Select
                  value={values.buyAmrcnInd}
                  onChange={value => {
                    changeValues('buyAmrcnInd', value);
                  }}
                >
                  {createOptions(productOptions.buyAmerican)}
                </Select>
              </div>
            </div>
            <div className="product-wrapper">
              <div className="product-partnum-flex">
                <p> Free Trade Agreements</p>
                <Select
                  value={values.freeTrdAgmts}
                  onChange={value => {
                    changeValues('freeTrdAgmts', value);
                  }}
                >
                  {createOptions(productOptions.freeTrade)}
                </Select>
              </div>
            </div>
          </Form.Item>

          {values.manufDlr === 'QD' && (
            <Form.Item>
              <div className="product-wrapper">
                <div className="product-partnum-flex">
                  <p>Source of Supply CAGE Code</p>

                  <Input
                    style={{ width: '10%' }}
                    maxLength="5"
                    value={values.sosCage}
                    onChange={e => changeValues('sosCage', e.target.value)}
                  />
                </div>
              </div>
            </Form.Item>
          )}
          <Form.Item
            label={
              <p style={{ fontWeight: 800, margin: 0 }}>
                Hazardous Material Identification and Material Safety Data{' '}
              </p>
            }
          >
            <div>
              <p>
                Identify hazardous material to be delivered under any resultant
                contract as prescribed by FAR 52.223 - 3.
              </p>
              <Radio.Group
                value={values.hazMatMsd}
                onChange={e => {
                  changeValues('hazMatMsd', e.target.value);
                }}
              >
                <Radio value="Y">Yes</Radio>
                <Radio value="N">No</Radio>
              </Radio.Group>
            </div>
          </Form.Item>

          {values.hazMatMsd === 'Y' && (
            <Form.Item
              label={
                <p style={{ fontWeight: 800, margin: 0 }}>
                  Hazardous Warning Labels{' '}
                </p>
              }
            >
              <Select
                value={values.hazMatWarning}
                onChange={value => {
                  changeValues('hazMatWarning', value);
                }}
              >
                {createOptions(productOptions.hazmat)}
              </Select>
            </Form.Item>
          )}
          <Form.Item
            label={
              <p style={{ fontWeight: 800, margin: 0 }}>
                Quantity Available for Immediate Shipment
              </p>
            }
          >
            <p>is there a quantity available for immediate shipment?</p>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Radio.Group
                value={values.quantityAvailableBool}
                onChange={e => {
                  changeValues('quantityAvailableBool', e.target.value);
                }}
              >
                <Radio value="N">No</Radio>
                <Radio value="Y">Yes</Radio>
              </Radio.Group>
              {values.quantityAvailableBool === 'Y' && (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <p
                    style={{
                      margin: 0,

                      marginLeft: '8px',
                      marginRight: '4px',
                    }}
                  >
                    Quantity:
                  </p>
                  <NumberFormat
                    style={{ width: 100 }}
                    className="nf-rff-input-field__input form-control"
                    value={values.quantityAvailable}
                    onChange={e => {
                      changeValues('quantityAvailable', e.target.value);
                    }}
                  />
                  <p
                    style={{
                      margin: 0,
                      marginLeft: '8px',
                      marginRight: '4px',
                    }}
                  >
                    Price:
                  </p>
                  <NumberFormat
                    className="nf-rff-input-field__input form-control"
                    style={{ width: 100 }}
                    value={values.quantityPrice}
                    onChange={e => {
                      changeValues('quantityPrice', e.target.value);
                    }}
                  />
                  <p
                    style={{
                      margin: 0,
                      marginLeft: '8px',
                      marginRight: '4px',
                    }}
                  >
                    Delivery Days:
                  </p>
                  <NumberFormat
                    className="nf-rff-input-field__input form-control"
                    style={{ width: 100 }}
                    value={values.dlvyDays}
                    onChange={e => {
                      changeValues('dlvyDays', e.target.value);
                    }}
                  />
                </div>
              )}
            </div>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/DibbsTabs/productTab.jsx